module.exports = __webpack_public_path__ + "media/images/icon/icon-chevron-304b25f7f85e842df177d95788aed5b8.svg";